import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BoobleModalService } from 'booble-modal';
import { Subscription } from 'rxjs';
import { FinalitiesDto } from 'src/app/domain/models/dto/finalities.dto';
import { AuthenticationService } from 'src/app/shared/services';
import { FinalitiesService } from 'src/app/shared/services/finalities.service';

@Component({
  selector: 'app-finality-selection-inbound',
  templateUrl: './finality-selection-inbound.component.html',
  styleUrls: ['./finality-selection-inbound.component.scss'],
})
export class FinalitySelectionInboundComponent implements OnInit, OnDestroy {
  @Output('finalitySelectedInbound')
  finalitySelectedInbound: EventEmitter<FinalitiesDto> = new EventEmitter(null);
  @Input('rType') rType = null;
  @Input() warrenGlobalOnly?: boolean;

  finalities?: FinalitiesDto[];
  finalities$?: Subscription;
  selectedFinality?: FinalitiesDto;
  personType: string;
  isMobile = false;

  get individualId() {
    return +this.authService.getIndividualId();
  }

  get companyId() {
    return +this.authService.getCompanyId();
  }

  constructor(
    private readonly finalitiesService: FinalitiesService,
    private modalService: BoobleModalService,
    private readonly authService: AuthenticationService,
    private bottomSheet: MatBottomSheet
  ) {
    this.personType = this.individualId ? 'pf' : 'pj';
  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 820;

    this.finalities$ = this.finalitiesService
      .getByPersonType(this.personType, this.rType)
      .subscribe({
        next: (result) => {
          if (this.warrenGlobalOnly) {
            this.finalities = result.data.filter(
              (f) => f.id === 22 || f.id === 30
            );
          } else {
            this.finalities = result.data;
          }
        },
      });
  }

  ngOnDestroy(): void {
    this.finalities$?.unsubscribe();
  }

  select(finality: FinalitiesDto) {
    this.finalitySelectedInbound.emit(finality);
  }

  closeModal() {
    if (this.isMobile) {
      this.bottomSheet.dismiss();
    } else {
      this.modalService.dismiss(null);
    }
  }

  onFinalitySelect(finality: FinalitiesDto) {
    this.selectedFinality = finality;
  }
}
